import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createTheme } from '@mui/material/styles';

interface ThemeState {
  primaryColor: string;
  secondaryColor: string;
}

const initialState: ThemeState = {
  primaryColor: '#4A90E2', 
  secondaryColor: '#A8E6FF', 
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<{ primaryColor: string; secondaryColor: string }>) => {
      state.primaryColor = action.payload.primaryColor || "#4A90E2";
      state.secondaryColor = action.payload.secondaryColor ||  '#A8E6FF';
    },
  },
});

export const { setTheme } = themeSlice.actions;
export default themeSlice.reducer;